import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getClaimByClaimIdRequest } from '../../api/Claim/getClaimByClaimId';
import { getClaimContextSummaryRequest } from '../../api/Claim/getClaimContextSummaryQuery';

import * as ActionCreators from './actionCreators';
import * as ActionTypes from './actionTypes';

function* loadClaimSummaryWorker({ payload }) {
  yield executeSagaRequest(
    ActionTypes.LOAD_CLAIM_SUMMARY,
    getClaimContextSummaryRequest({ claimId: payload }),
  );

  yield put(ActionCreators.loadClaimSummaryEnd());
}
function* loadClaimSummaryWatcher() {
  yield takeEvery(ActionTypes.LOAD_CLAIM_SUMMARY.BASE, loadClaimSummaryWorker);
}

function* getClaimWorker({ payload }) {
  yield executeSagaRequest(
    ActionTypes.GET_CLAIM,
    getClaimByClaimIdRequest({ claimId: payload }),
  );

  yield put(ActionTypes.GET_CLAIM.end());
}
function* getClaimWatcher() {
  yield takeEvery(ActionTypes.GET_CLAIM.BASE, getClaimWorker);
}

export function* claimSaga() {
  try {
    yield all([loadClaimSummaryWatcher(), getClaimWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}

export default claimSaga;
